import { render } from "./iconMs.vue?vue&type=template&id=491dd6de"
import script from "./iconMs.vue?vue&type=script&lang=js"
export * from "./iconMs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__